import fetchParams from './fetch_params'
import modelsToActivities from './models_to_activities'

export default async function (models = []) {
  const activities = modelsToActivities(models)
  await Promise.all(activities.map((activity) => activity.fetch(fetchParams)))
  return models
}
